import React, { Component } from "react";
import PropTypes from "prop-types";
import selectn from "selectn";

import Headline from "../Headline";
import StoryBody from "../StoryBody";
import PrimaryImage from "../PrimaryImage";
import styles from "./StoryContent.css";

class StoryContent extends Component {
  render() {
    const { story, isSummary, storyType, permalinkId, index } = this.props;
    if (!story) return null;
    const isFeatured = story.is_featured && !isSummary;

    const textOverStory =
      selectn("rubric.name", story) || (isFeatured && "Featured");
    const textOverColor = selectn("rubric.hex_color", story);

    return (
      <div>
        {textOverStory && (
          <div
            className={styles.featured}
            style={textOverColor && { color: `#${textOverColor}` }}
          >
            {textOverStory}
          </div>
        )}
        {story.headline && (
          <Headline
            headline={story.headline}
            permalink={story.permalink}
            noLink={!isSummary}
          />
        )}
        {!isSummary && (
          <PrimaryImage image={story.primary_image} lazyload={index !== 0} />
        )}
        <StoryBody
          story={story}
          storyType={storyType}
          permalinkId={permalinkId}
        />
      </div>
    );
  }
}

StoryContent.propTypes = {
  story: PropTypes.object,
  storyType: PropTypes.oneOf(["newsletter"]),
  isSummary: PropTypes.bool,
  permalinkId: PropTypes.string,
};

export default StoryContent;
